// Lucide icon: toolbox (https://lucide.dev/icons/toolbox)
import { Toolbox } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconLabour = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Toolbox />
    </IconComponentStyled>
  )
}
